<template>
  <teleport to="body">
    <transition-group name="toast">
      <div
        v-for="(item, index) in toasts"
        :key="item.id"
        class="fixed left-1/2 -translate-x-1/2 z-50 transition-all duration-300"
        :style="{ bottom: `calc(var(--safe-area-inset-bottom, 0px) + ${16 + index * 80}px)` }"
      >
        <toast
          :message="item.message"
          :type="item.type"
          :title="item.title"
          :action-text="item.actionText"
          :on-action="item.onAction"
          @close="removeToast(item.id)"
        />
      </div>
    </transition-group>
  </teleport>
</template>

<script setup lang="ts">
import { v4 as uuid } from 'uuid'
import { ref } from 'vue'

import { init } from './toast'
import type { ToastProps } from './toast'
import Toast from './Toast.vue'

type ToastItem = ToastProps & {
  id: string
}

const toasts = ref<ToastItem[]>([])

function show(props: ToastProps) {
  const id = uuid()

  toasts.value.push({
    ...props,
    id
  })

  const duration = props.duration ?? (props.type === 'error' ? 5000 : 3000)

  setTimeout(() => {
    removeToast(id)
  }, duration)
}

function removeToast(id: string) {
  const index = toasts.value.findIndex(t => t.id === id)
  if (index !== -1) {
    toasts.value.splice(index, 1)
  }
}

init(show)
</script>

<style scoped>
.toast-enter-active {
  transition:
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-leave-active {
  transition:
    transform 0.15s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-enter-from {
  transform: translate(-50%, 100%);
  opacity: 0;
}

.toast-leave-to {
  transform: translate(-50%, 100%);
  opacity: 0;
}

.toast-move {
  transition: bottom 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
